/**
 * SxaQuestionInputDynamicBandTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import SxaScoreInputSliderTile from "./SxaScoreInputSliderTile";

class SxaQuestionInputDynamicBandTile extends React.Component {
    constructor(props) {
        super(props);

        // Compute the dynamic band label
        var currQ = props.q;
        var currBandLabel = this.getBandLabelForScore(currQ, currQ.score);

        // Assign Q ref to state for refresh
        this.state = {
            q: props.q,
            qscore: currQ.score,
            bandlabel: currBandLabel
        };
    }

    // FIXME - convert to a lookup function
    getBandLabelForScore( question, score) {
        var currBandLabel;
        if (score < 25) {
            currBandLabel = question.bandLabelOne;
        }
        else if (score < 50) {
            currBandLabel = question.bandLabelTwo;
        }
        else if (score < 75) {
            currBandLabel = question.bandLabelThree;
        }
        else {
            currBandLabel = question.bandLabelFour;
        }
        return currBandLabel;
    }

    changeQuestion(newQ) {
        //console.log("Question context was changed; new Q = " + newQ.oid);

        // Compute the dynamic band label
        var newQScore = newQ.score;
        var currBandLabel = this.getBandLabelForScore(newQ, newQScore);

        // Force re-render
        this.setState( state => ({ q: newQ, qscore: newQScore, bandlabel: currBandLabel}) );

        // N.B. Slider does not reset for new Q - more update work needed
        // Re-bind the Q-Input tile
        this.sis.changeQuestion(newQ);
    }

    // Callback function used by child to signal score change
    refreshQScore = (signal, newscore) => {
        //console.log("Score was refreshed; signal = " + signal +
        //    "; newscore = " + newscore);

        // Compute the dynamic band label
        var currBandLabel = this.getBandLabelForScore(this.state.q, newscore);

        // Force re-render
        // Of specific children? No
        this.setState({q: this.state.q, qscore: newscore, bandlabel: currBandLabel })

        //  Signal the Assessment_Input container - callback function
        if (signal === true) {
            this.props.handleScoreChange();
        }
    };

    // FIXME - get Q-input area to use the available height - push nav controls to bottom of screen
    // FIXME - AND nav buttons must not move (same issue as landscape) - put in the footer AppBar??
    // - Start vs Back/Next vs. Finish (create a Portrait Controls tile - with dynamic render of buttons...)
    render() {
        return (
            <React.Fragment>
                {this.state.q ? (
                    <div style={{ background: 'white',
                        padding: 12,
                        paddingTop: 6,
                        minHeight: '240px',
                        overflowX: 'hidden',
                        overflowY: 'hidden'
                    }}>
                        <Typography align="center" color="inherit" style={{ fontSize: 14, padding: '0.15em' }}>
                            {this.state.q.text}
                        </Typography>
                        <Typography align="center" color="inherit" style={{ fontSize: 22, padding: '0.15em', paddingBottom: '0.5em' }}>
                            {this.state.qscore}
                        </Typography>
                        <SxaScoreInputSliderTile q={this.state.q}
                                                 ref={(sis) => { this.sis = sis; }}
                                                 refreshQScore={this.refreshQScore}
                        />
                        <Grid container spacing={0} direction="row" justify="center" alignItems="flex-start"
                              style={{padding: 0}}>
                            <Grid item xs={3} sm={3} lg={3} xl={3}>
                                <Typography color="inherit" style={{ fontSize: 14,
                                    //borderTop: '0.1em solid lightgrey',
                                    borderLeft: '0.1em solid lightgrey',
                                    padding: '0.5em' }}>
                                </Typography>
                            </Grid>
                            <Grid item xs={3} sm={3} lg={3} xl={3}>
                                <Typography color="inherit" style={{ fontSize: 14,
                                    //borderTop: '0.1em solid lightgrey',
                                    borderLeft: '0.1em solid lightgrey',
                                    padding: '0.5em' }}>
                                </Typography>
                            </Grid>
                            <Grid item xs={3} sm={3} lg={3} xl={3}>
                                <Typography color="inherit" style={{ fontSize: 14,
                                    //borderTop: '0.1em solid lightgrey',
                                    borderLeft: '0.1em solid lightgrey',
                                    padding: '0.5em' }}>
                                </Typography>
                            </Grid>
                            <Grid item xs={3} sm={3} lg={3} xl={3}>
                                <Typography color="inherit" style={{ fontSize: 14,
                                    //borderTop: '0.1em solid lightgrey',
                                    borderLeft: '0.1em solid lightgrey',
                                    borderRight: '0.1em solid lightgrey',
                                    padding: '0.5em' }}>
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={0} direction="row" justify="center" alignItems="flex-start"
                              style={{padding: 0}}>
                            <Grid item xs={3} sm={3} lg={3} xl={3}>
                                <Typography color="inherit" align="left" style={{ fontSize: 12, color: "#517992",
                                    padding: '0em' }}>
                                    0
                                </Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} lg={2} xl={2}>
                                <Typography color="inherit" align="left" style={{ fontSize: 12, color: "#517992",
                                    padding: '0em' }}>
                                    25
                                </Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} lg={2} xl={2}>
                                <Typography color="inherit" align="center" style={{ fontSize: 12, color: "#517992",
                                    padding: '0em' }}>
                                    50
                                </Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} lg={2} xl={2}>
                                <Typography color="inherit" align="right" style={{ fontSize: 12, color: "#517992",
                                    padding: '0em' }}>
                                    75
                                </Typography>
                            </Grid>
                            <Grid item xs={3} sm={3} lg={3} xl={3}>
                                <Typography color="inherit" align="right" style={{ fontSize: 12, color: "#517992",
                                    padding: '0em' }}>
                                    100
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={0} direction="row" justify="center" alignItems="flex-start"
                              style={{padding: 0, marginTop: '1.0em'}}>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <Typography align="center" color="inherit"
                                            style={{ fontSize: 12, padding: '0.5em', color: "#517992"}}>
                                    {this.state.bandlabel}
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                ) : "No Question found"}
            </React.Fragment>
        )
    }
}

/*
From band label:
borderRight: '0.1em solid lightgrey',
borderLeft: '0.1em solid lightgrey',
 */

export default SxaQuestionInputDynamicBandTile;